import type { Table } from "common/data/table";
import { docEntityNameWithCount } from "./docEntityNameWithCount";

export function docEntityNameWithCountFromTable(candidateName: string, names: Table<{ name?: string }>) {
  return docEntityNameWithCount(candidateName, Object.values(names));
}
